import React, { ChangeEvent, InputHTMLAttributes } from 'react';

interface PhoneInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> {
  value: string;
  onChange: (value: string) => void;
}

export const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange, className, ...props }) => {
  const formatPhoneNumber = (input: string) => {
    // Strip all non-digit characters
    let digits = input.replace(/\D/g, '');

    // Handle early returns or prefix setting
    if (!digits) return '';

    // If starts with 8, convert to 7
    if (digits.startsWith('8')) {
      digits = '7' + digits.slice(1);
    } else if (!digits.startsWith('7')) {
      digits = '7' + digits;
    }

    // Limit to 11 digits max (+7 and 10 digits for the number)
    digits = digits.substring(0, 11);

    // Build the formatted string
    let result = '+7';
    
    if (digits.length > 1) {
      result += ' (' + digits.substring(1, 4);
    }
    if (digits.length >= 5) {
      result += ') ' + digits.substring(4, 7);
    }
    if (digits.length >= 8) {
      result += '-' + digits.substring(7, 9);
    }
    if (digits.length >= 10) {
      result += '-' + digits.substring(9, 11);
    }

    return result;
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    
    // Check if the user is clearing the input entirely
    if (rawValue === '' || rawValue === '+') {
      onChange('');
      return;
    }

    const formattedValue = formatPhoneNumber(rawValue);
    onChange(formattedValue);
  };

  return (
    <input
      type="tel"
      value={value}
      onChange={handleChange}
      placeholder="+7 (___) ___-__-__"
      className={`block w-full px-4 py-3 rounded-xl border border-gray-200 text-gray-900 placeholder-gray-400 focus:ring-2 focus:ring-goszakup-600 focus:border-transparent transition-all sm:text-sm ${className || ''}`}
      {...props}
    />
  );
};

export default PhoneInput;
